<template>
  <div>
    <div class="p-4">
      <div class="panel-header">
        <h2 class="h4 text-black">New Sites</h2>
        <p>These are sites trying to join your KoalaBoss:</p>
      </div>
      <c-row
          v-for="(site, index) in sites"
          :key="`site_${index}`"
          class="py-2 site-row"
      >
        <site-card :site="site" :hide-plugins="true" :read-only="true">
          <template #footer>
            <c-button-group class="float-right">
              <c-button
                  color="kb-green"
                  size="sm"
                  @click="confirmAddToDashboard(site)"
              >
                Accept
              </c-button>
              <c-button
                  color="danger"
                  size="sm"
                  @click="confirmIgnoreSite(site)"
              >
                Ignore
              </c-button>
            </c-button-group>
          </template>
        </site-card>
      </c-row>
    </div>
    <!--     @TODO - need to add load state onto modal -->
    <confirm-modal
        color="primary"
        title="Add this site to your dashboard?"
        okText="Add"
        :show.sync="showAddToDashboard"
        @update:confirm="addToDashboard"
    >
      <template v-if="selectedSite">
        <h3 class="h5" v-html="selectedSite.name"/>
        <p>{{selectedSite.siteAddress}}</p>
      </template>
    </confirm-modal>
    <confirm-modal
        color="danger"
        title="Ignore site"
        okText="Ignore"
        :show.sync="showSiteIgnore"
        @update:confirm="ignoreSite"
    >
      <template v-if="selectedSite">
        <h2 class="h4 pb-4">Ignore this site? It will no longer appear as a pending site.</h2>
        <h3 class="h5">{{selectedSite.name}}</h3>
        <p>{{selectedSite.siteAddress}}</p>
      </template>
    </confirm-modal>
  </div>
</template>

<script>
import ConfirmModal from '@/views/components/ConfirmModal';
import { buildEndpoint } from '@/libs/buildEndPoint';
import SiteCard from '@/views/components/site/Card';

export default {
  name: 'PendingSites',
  components: {
    ConfirmModal,
    SiteCard,
  },
  props: {
    sites: Array,
    readOnly: Boolean,
    hideHeader: Boolean,
    noBox: Boolean,
    md: String,
    lg: String,
  },
  data() {
    return {
      error: null,
      showAddToDashboard: false,
      showSiteIgnore: false,
      addSiteMessage: 'add this',
      selectedSite: null,
      isSending: false,
    };
  },
  mounted() {},
  methods: {
    addToDashboard() {
      const { _id: siteId } = this.selectedSite;
      this.$http
        .get(buildEndpoint(`site/add-pending/${siteId}`))
        .then((response) => {
          this.isSending = false;
          if (response.data.success) {
            this.$router.push({ name: 'detailsSite', params: { siteId } });
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: `${response.data.message}${response.data.error ? `: ${response.data.error}` : ''}`,
            });
          }
        })
        .catch((error) => {
          this.isSending = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error.message,
          });
        });
    },
    ignoreSite() {
      const { _id: siteId } = this.selectedSite;
      this.$http
        .get(buildEndpoint(`site/ignore-pending/${siteId}`))
        .then((response) => {
          this.isSending = false;
          if (response.data.success) {
            // Clear from list
            this.$emit('siteIgnored', siteId);
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: `${response.data.message}${response.data.error ? `: ${response.data.error}` : ''}`,
            });
          }
        })
        .catch((error) => {
          this.isSending = false;
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: error.message,
          });
        });
    },
    confirmIgnoreSite(site) {
      this.selectedSite = site;
      this.showSiteIgnore = true;
    },
    confirmAddToDashboard(site) {
      this.selectedSite = site;
      this.showAddToDashboard = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/colors.scss';
.c-dark-theme {
  .panel-header {
    color: $kb-grey-dark;
  }
}
</style>
